import { createAsyncThunk } from "@reduxjs/toolkit";
import apiRequest from "../../../services/api";

export const enableOrDisableOrgCode = createAsyncThunk(
  "/org_code/toggle",
  async (body) => {
    const verifyDetails = await apiRequest.post(
      `v1/organizations/org_code/`,
      body.values,
      { headers: { organization: body.userOrganization.org_id } }
    );
    return verifyDetails.data;
  }
);

export const updateOrgCode = createAsyncThunk(
  "/org_code/refresh",
  async (body) => {
    const verifyDetails = await apiRequest.put(
      `v1/organizations/org_code/`,
      "",
      {
        headers: { organization: body.userOrganization.org_id },
      }
    );
    return verifyDetails.data;
  }
);
